import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from '@/i18n/client';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  theme?: string;
  background?: string;
  className?: string;
  footer?: React.ReactNode;
  lang?: string;
  childClassName?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  theme = 'second',
  background = 'bg-white',
  className = 'z-999',
  footer,
  lang = 'zh-HK',
  childClassName = 'w-10/12',
}) => {
  const { t } = useTranslation(lang);
  const themeClasses = {
    first: 'bg-white',
    second: 'bg-custom-gradient',
  };
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'; // 禁用滚动
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = ''; // 清理样式
    };
  }, [isOpen]);

  if (!isOpen) return null;

  if (theme === 'first') {
    return ReactDOM.createPortal(
      <div
        className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-black bg-opacity-60 h-full overflow-y-auto py-6 ${className}`}
      >
        <div
          className={`${background} rounded-lg shadow-lg p-6 ${childClassName} !max-w-screen-xs`}
        >
          {children}
        </div>
        {footer ?? (
          <div className="py-2" onClick={() => onClose?.()}>
            {t('modal.close')}
          </div>
        )}
      </div>,
      document.body,
    );
  } else {
    return ReactDOM.createPortal(
      <div
        className={`fixed inset-0 z-50 flex flex-col items-center justify-center bg-white !bg-opacity-70 h-full overflow-y-auto py-6 ${className}`}
      >
        <div className={`${background} rounded-lg w-10/12 ${childClassName}`}>{children}</div>
        {footer ?? (
          <div className="py-2 text-[#000]" onClick={() => onClose?.()}>
            {t('modal.close')}
          </div>
        )}
      </div>,
      document.body,
    );
  }
};
